<script>

    import Button from "./Button.svelte";

    import { _ } from 'svelte-i18n';

    let dialog;
    let resolve;
    let errorCode = $state('');
    let pending = null;

    function openDialog() {
        if (typeof dialog?.showModal === 'function') {
            dialog.showModal();
        } else if (dialog) {
            dialog.setAttribute('open', '');
        }
    }

    function closeDialog() {
        if (typeof dialog?.close === 'function') {
            dialog.close();
        } else if (dialog) {
            dialog.removeAttribute('open');
        }
    }

    export function show(code) {
        errorCode = code || '';

        if (dialog?.hasAttribute('open')) {
            return pending;
        }

        pending = new Promise((res) => {
            resolve = res;
            openDialog();
        });

        return pending;
    }

    function handleRetry() {
        closeDialog();
        resolve?.();
    }

    function handleClose() {
        resolve?.();
    }

</script>

<dialog bind:this={dialog} onclose={handleClose} aria-labelledby="connection-dialog-title">
    {#if errorCode === 'NO_CONNECTION'}
        <h3 id="connection-dialog-title">{$_('no_internet')}</h3>
        <p>{$_('no_internet_description')}</p>
    {:else}
        <h3 id="connection-dialog-title">{$_('connection_failed')}</h3>
        <p>{$_('connection_failed_description')}</p>
    {/if}

    {#if errorCode}
        <code>{errorCode}</code>
    {/if}

    <Button color="accent" onclick={handleRetry}>
        {$_('retry')}
    </Button>
</dialog>


<style>

    dialog {
        border: none;
        border-radius: var(--card-radius);
        padding: 2em;
        max-width: 36em;
        text-align: left;

        background: #fff;
        color: #000;
        box-shadow: 0 0 20px rgba(0,0,0,.15),0 20px 40px rgba(0,0,0,.05);
    }

    @media (prefers-color-scheme: dark) {
        dialog {
            background: #333;
            color: #fff;
            box-shadow: 0 0 20px rgba(0,0,0,.5), 0 20px 40px rgba(0,0,0,.3);
        }
    }

    @media (max-width: 600px) {
        dialog {
            margin-left: 1em;
            margin-right: 1em;
        }
    }

    :global(::backdrop) {
        background: rgba(0, 0, 0, 0.4);
    }

    @media (prefers-color-scheme: dark) {
        :global(::backdrop) {
            background: rgba(0, 0, 0, 0.6);
        }
    }

    h3 {
        font-family: var(--theme-alt-font-family);
        font-weight: var(--theme-font-weight);
        font-size: 2em;
        margin: 0;
    }

    p {
        font-size: 0.95em;
        opacity: 0.6;
    }

    code {
        display: inline-block;
        font-size: 0.8em;
        opacity: 0.4;
        margin-bottom: 2em;
    }

</style>
